export default __webpack_public_path__ + "static/trackthebat8-b9f201a454f696d02047d3a47f267f0f.png";